<script lang="ts">
  import { page } from '$app/stores';
  import Button from '$lib/components/control/Button.svelte';
  import { ACCORDION_ITEM_VARIANT, BUTTON_SIZE, BUTTON_VARIANT } from '$lib/constants/constants';
  import type { HeaderNavigationProps, NavigationItemProps } from '$lib/types/layoutTypes';
  import Accordion from '../accordion/Accordion.svelte';
  import AccordionItem from '../accordion/AccordionItem.svelte';
  import { clickOutside } from '$lib/helpers/clickOutside';

  export let ctaBackgroundColor: string | undefined = '';
  export let ctaTextColor: string | undefined = '';
  export let ctaTitle: string | undefined = '';
  export let ctaUrl: string | undefined = '';
  export let isVisible: boolean = false;
  export let navigation: HeaderNavigationProps | undefined;
  export let handleMobileMenu: Function = () => {};

  // To prevent the outside click closing as soon as the menu opens
  let initialClick = false;

  $: navigationWithSubNavigationMobile = navigation?.length
    ? navigation?.reduce((memo: HeaderNavigationProps, navigationItem) => {
        const subNavigationItems: Array<NavigationItemProps> =
          navigationItem?.subNavigationItemsCollection?.items || [];
        let newSubNavigationItems: Array<NavigationItemProps> = []; // make a copy of the original array
        if (subNavigationItems.length && navigationItem?.mobileTitle && navigationItem?.url) {
          newSubNavigationItems = [
            {
              title: navigationItem.mobileTitle,
              url: navigationItem.url,
            },
          ].concat(subNavigationItems);
        }
        memo.push({
          ...navigationItem,
          subNavigationItemsCollection: { items: newSubNavigationItems },
        });

        return memo;
      }, [])
    : [];

  $: isVisibleClass = isVisible ? 'visible' : 'invisible';
  $: ctaCustomTextColor = ctaTextColor ? ` color: ${ctaTextColor};` : '';
  $: ctaCustomBgColor = ctaBackgroundColor ? ` background: ${ctaBackgroundColor};` : '';
  $: !isVisible && (initialClick = false);
  const customClass = 'w-full';
  let path;
  $: path = $page.url.pathname;
</script>

<div
  class="absolute top-[72px] h-[calc(100dvh_-_132px)] left-0 right-0 bg-transparent overflow-scroll {isVisibleClass} lg:hidden"
>
  <div
    class="relative overflow-scroll z-50 bg-white pb-6"
    use:clickOutside
    on:outsideclick|stopPropagation|preventDefault={() => {
      if (isVisible) {
        if (initialClick) {
          handleMobileMenu();
        } else {
          initialClick = true;
        }
      }
    }}
  >
    <div class="py-6 border-b-[1px] border-gray-200">
      <Accordion collapse>
        {#if navigationWithSubNavigationMobile?.length}
          {#each navigationWithSubNavigationMobile as navigationItem}
            {#if navigationItem?.subNavigationItemsCollection?.items?.length}
              <AccordionItem
                open={false}
                variant={ACCORDION_ITEM_VARIANT.NAV}
                customClass="[&:not(:first-child)]:mt-2"
              >
                <p
                  slot="title"
                  class="text-gray-900 font-semibold {path.startsWith(navigationItem.url)
                    ? '!font-bold'
                    : ''}"
                >
                  {navigationItem.title}
                </p>
                <div class="py-4 mt-2" slot="content">
                  {#each navigationItem?.subNavigationItemsCollection?.items as subNavigationItem}
                    <a
                      class="flex py-3 text-gray-700 {path.startsWith(subNavigationItem.url)
                        ? 'font-bold'
                        : ''}"
                      href={subNavigationItem?.url}>{subNavigationItem?.title}</a
                    >
                  {/each}
                </div>
              </AccordionItem>
            {:else}
              <a class="flex text-gray-900 font-semibold ml-4 py-3 mt-2" href={navigationItem.url}>
                {navigationItem?.title}
              </a>
            {/if}
          {/each}
        {/if}
      </Accordion>
    </div>
    {#if !$page.url.href.includes('join')}
      <div class="px-4 pt-6">
        <Button
          buttonSize={BUTTON_SIZE.LARGE}
          variant="variant={BUTTON_VARIANT.PRIMARY}"
          text={ctaTitle}
          customStyle={ctaCustomBgColor + ctaCustomTextColor}
          {customClass}
          url={ctaUrl}
        />
      </div>
    {/if}
  </div>
</div>
